module.exports = __webpack_public_path__ + "img/MyPCP-logo-mark.97a80962.svg";